import BaseApi from '../../base/base'
import { QuestionForm } from '../../../forms/exam_comparison';
import Exam from '../../../models/exam';

export default class ExamApi extends BaseApi {
  constructor() {
    super()
    this.path = '/admin/exams'
  }

  async index(name = '',type = Exam.TYPE_NORMAL_EXAM) {
    this.path = '/admin/exams'
    const response = await this.getRequest({ type, name })
    return response.data.exams.map((element) => {
      return new Exam(element)
    })
  }

  async patch(examId, params: QuestionForm[]) {
    this.path = `/admin/exams/${examId}`
    const response = await this.patchRequest({
      questionForms: params
    })
    return response
  }

  async post(stocks: { examId: number, questionCount: number }[] = []) {
    this.path = '/admin/exams'
    const response = await this.postRequest({ stocks })
    return response
  }
}
